var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-qna-container l-qna-container_questions"},[_c('div',{staticClass:"l-question-box"},[_c('p',{staticClass:"question-copy",domProps:{"innerHTML":_vm._s(_vm.trivia.question)}})]),_c('div',{staticClass:"l-question-answers l-question-answers_tf"},_vm._l((_vm.trivia.answers),function(answer,index){return _c('div',{key:index,staticClass:"answer-item"},[_c('button',{class:[
					'btn btn-answer',
					{
						'btn-answer-true': answer.toLowerCase() === 'true',
						'btn-answer-false': answer.toLowerCase() === 'false'
					}
				],domProps:{"innerHTML":_vm._s(answer)},on:{"click":function($event){return _vm.$emit('answer', answer)}}})])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }